// extracted by mini-css-extract-plugin
export default {"medDagen":"MedDagen_medDagen__GTIkR","glow":"MedDagen_glow__F9WZC","gradientMove":"MedDagen_gradientMove__KDRkD"};